﻿'use strict';

var vm;
var vm1;
var vm2;
var dataselectors;
var listActionType;
var listOperationType;
var lastIdAppointment;

//Visualizacion del listado de Appointments
(function () {
    var controllerId = 'appointmentSearchMainCtrl';

    angular
        .module('app.controllers')
        .controller(controllerId, appointmentSearchMainCtrl)
        .directive("datepicker", function () {
            return {
                restrict: "A",
                require: "ngModel",
                link: function (scope, elem, attrs, ngModelCtrl) {
                    var updateModel = function (dateText) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(dateText);
                        });
                    };
                    var options = {
                        dateFormat: "dd/mm/yy",
                        onSelect: function (dateText) {
                            updateModel(dateText);
                        }
                    };
                    $(elem).datepicker(options);
                }
            }
        });

    //$modal no existe cuando se vincula el bootstrap solo  
    appointmentSearchMainCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$translate', '$timeout', '$state', '$element', '$sce', '$window', '$stateParams', 'vsblockui', 'moment', 'ngDialog', '$rootScope'];

    function appointmentSearchMainCtrl(common, datacontext, $http, $scope, $translate, $timeout, $state, $element, $sce, $window, $stateParams, vsblockui, moment, ngDialog, $rootScope) {
        var config = common.config;
        vm = this;
        vm.spinnerOptions = {
            radius: 20,
            lines: 11,
            length: 1,
            width: 8,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#146794'
        };

        //vm.actionRefresh = false;
        vm.display = false;

        vm.test = ':D';

        //appointment list
        vm.appointments = [];
        vm.varequipmentlist = [];

        vm.appointmentStatusList = {};
        vm.yardsList = {};
        vm.actionTypeList = {};
        vm.operationTypeList = {};
        vm.varstatus = null;
        vm.varyard = {};
        vm.varaction = {};

        /*---paginación----*/
        vm.TotalItems = 0;
        vm.ItemsPerPage = 10;
        vm.CurrentPage = 1;

        //functions
        vm.startDate = startDate;
        vm.endDate = endDate;
        vm.getAppointments = getAppointments;
        vm.showModalApptView = showModalApptView;
        vm.showModalGoToEdit = showModalGoToEdit;
        vm.gotoCreate = gotoCreate;
        vm.gotoCreate2 = gotoCreate2;
        vm.gotoEdit = gotoEdit;
        vm.startDatepicker = startDatepicker;
        vm.clickStatus = clickStatus;
        vm.clickActionType = clickActionType;
        vm.crearBtnTipoOperacion = crearBtnTipoOperacion;
        vm.crearBtnTipoAccion = crearBtnTipoAccion;
        vm.crearBtnTipoAccionSmall = crearBtnTipoAccionSmall;
        vm.verDetalleCita = verDetalleCita;
        vm.nombreTipoOperacion = nombreTipoOperacion;
        vm.nombreTipoAccion = nombreTipoAccion;
        vm.formatDisplayDate = formatDisplayDate;
        vm.muestraEquipos = muestraEquipos;
        vm.redirectAction = redirectAction;
        vm.setDefaultYardIfNotSet = setDefaultYardIfNotSet;
        vm.downloadExcel = downloadExcel;

        //appointment selection view
        vm.datevalstart = null;
        vm.datevalend = null;

        vm.varaditional = "";
        vm.varappointmentno = "";
        vm.varappointdate = "";
        vm.varappointtime = "";
        vm.varappointyard = "";
        vm.varappointstatus = "";
        vm.varplateno = "";
        vm.vardrivername = "";
        vm.vartruckername = "";

        vm.varactiontype = "";
        vm.varoperationtype = "";
        vm.nro_registros = "";
        vm.checksForAppCreation = [];
        var authData = common.localStorageService.get('authorizationData');
        vm.roleSelected = authData ? authData.userRole : "";
        vm.isOnlyPortalUser = authData ? authData.isOnlyPortalUser : false;

        vm.muestraAcordeon = muestraAcordeon;

        var lbl_All = $translate.instant('views.appointment.all');

        vm.pageSize = '500';
        vm.yards = [];

        function viewCellRendering() {
            return '<img class="srch" src="../../../assets/img/icons/search.png">';
        }

        function editCellRendering() {
            return '<img class="edt" src="../../../assets/img/icons/edit.png">';
        }

        function verDetalleCita(appointmentId) {

            if (typeof appointmentId != "undefined")
                vm1.showModalApptView(appointmentId);
            else
                alert('completar appointmentId');
        }

        function gotoCreate() {
            $state.go("root.appointmentMainApptSchedule", { reload: true });
        }

        function gotoCreate2() {
            $state.go("root.appointmentCreate2", { reload: true });
        }

        function gotoEdit(Alpha, Type, TypeHours, TypeDate, AppointmentId, AppointmentTemplateId, ActionType, OperationType) {
            //uncheck and remove previous selected appointments
            vm.checksForAppCreation = [];
            common.localStorageService.set('apptsInfo', { apptsinfo: null });
            $('div.k-event-template span input[type=checkbox]').prop('checked', false);

            var Validate = new Date();
            var validarCrearCita;
            AppointmentId = parseInt(AppointmentId);
            Type = Boolean(Type);
            TypeDate = new Date(TypeDate);
            TypeHours = parseInt(TypeHours);
            AppointmentTemplateId = parseInt(AppointmentTemplateId);
            Alpha = new Date(Alpha);

            //si la fecha de la cita es igual o mayor a la fecha actual, permite crear o editar
            if ((Alpha == Validate) || (Alpha > Validate)) {

                    if (AppointmentId > 0) {
                        //fecha de la cita mayor a la fecha actual
                        if (Alpha > Validate)
                            validarCrearCita = true;
                        else
                            validarCrearCita = false; //flag para campos en gris

                        var hoursDifference = Math.abs(Alpha - Validate) / 36e5;
                        if (TypeHours > hoursDifference)
                            $window.sessionStorage.editDisabled = true;
                        else
                            $window.sessionStorage.editDisabled = false;
                    }
            }
            else {
                //en la edicion hace como que crea una cita para que mande toda la informacion interna
                //pero tambien manda el flag para que deshabilite los campos cambiables y el boton de edicion
                validarCrearCita = true;
                $window.sessionStorage.editDisabled = true;
            }

            if (validarCrearCita == true) {
                var hours = Alpha.getHours();
                var minutes = Alpha.getMinutes();
                var ampm = hours >= 12 ? 'PM' : 'AM';

                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;

                var HourString = hours + ':' + minutes + ' ' + ampm;
                var DateString = ("0" + (Alpha.getMonth() + 1)).slice(-2) + "/" + ("0" + Alpha.getDate()).slice(-2) + "/" + Alpha.getFullYear();

                $window.sessionStorage.idYard = angular.copy(vm.varyard);
                common.localStorageService.set('selectedYard', {
                    yard: vm.varyard
                });

                $window.sessionStorage.codeActionType = angular.copy(ActionType);
                $window.sessionStorage.codeOperationType = angular.copy(OperationType);
                $window.sessionStorage.dateString = angular.copy(DateString);
                $window.sessionStorage.hourString = angular.copy(HourString);

                $window.sessionStorage.appointmentId = angular.copy(AppointmentId);
                $window.sessionStorage.appointmentTemplateId = angular.copy(AppointmentTemplateId);
                $window.sessionStorage.alpha = angular.copy(Alpha);
                $window.sessionStorage.type = angular.copy(Type);
                $window.sessionStorage.typeHours = angular.copy(TypeHours);
                $window.sessionStorage.typeDate = angular.copy(TypeDate);
                $rootScope.__AppointmentTemplateId__ = angular.copy(AppointmentTemplateId);
                vm.showModalGoToEdit();
            }
            else {
                toastr.error('Expiro el tiempo para la creación');
            }
        }

        function startDatepicker() {
            getAppointments();
        }

        function showModalGoToEdit() {
            $rootScope.startDatepicker = startDatepicker;
            $scope.checksForAppCreation = vm.checksForAppCreation;
            ngDialog.open({
                template: 'app/components/appointment/appointmentCreate2.html',
                closeByDocument: false,
                closeByEscape: false
            });
        }

        vm.fnConfigureControls = function () {
            $('#txtFromDate').datepicker({
                format: 'dd/mm/yyyy'
            });
            $('#txtToDate').datepicker({
                format: 'dd/mm/yyyy'
            });
        }

        vm.fnFillFromToDate = function () {
            var now = moment();
            vm.datevalstart = now.clone().add(-1, 'day').format("DD/MM/YY");
            vm.datevalend = now.format("DD/MM/YY");
        }

        init();

        function init() {
            //vm.actionRefresh = true;
            vm.fnFillFromToDate();
            vm.fnConfigureControls();
            common.activateController([getAppointmentPromiseConfig(), GetFilterPromise(), GetYards2()])
                .then(function (data) {
                    if (data && data[0]) {
                        LoadAppointmentData(data[0]);
                    }
                    if (data && data[1]) {
                        getActionTypes(data[1]);
                        getOperationTypes(data[1]);
                        getStatusByLanguage(data[1]);
                        getYards(data[1]);
                    }

                    var $sched = $("#schedulerAppointment");
                    if ($sched) {
                        kendo.unbind($sched);
                        kendo.destroy($sched);
                    }
                   // vm.actionRefresh = false;
                },
                function (err) {
                    ng.actionSearch = false;
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        function GetFilterPromise() {
            return datacontext.appointment.getFilters();
        }

        function GetYards2() {
            return datacontext.appointment.getYards().then(function (result) {
                if (result)
                    vm.yards = result;
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getActionTypes(data) {
            if (data) {
                data.ActionTypes.splice(0, 0, { ActionTypeId: 0, Name: lbl_All, isactive: 1 });
                
                listActionType = vm.actionTypeList = data.ActionTypes;
            }
        }

        function getOperationTypes(data) {
            if (data) {
                data.OperationTypes.splice(0, 0, { Code: "T", Name: lbl_All, isactive: 1 });
                listOperationType = vm.operationTypeList = data.OperationTypes;
                vm.varoperationtype = "T";
            }
        }

        function getStatusByLanguage(data) {
            if (data) {
                data.AppointmentStatuses.splice(0, 0, { EntityStatusTypeId: 0, Name: lbl_All, isactive: 1 });
                vm.appointmentStatusList = data.AppointmentStatuses;
                vm.varstatus = data.AppointmentStatuses[0].EntityStatusTypeId;
            }
        }

        function getYards(data) {
            var yardLst = [];
            angular.forEach(common.localStorageService.get('yardList'), function (value, key) {
                var yards = $(vm.yards).filter(function (a, b) {
                    return b.Code == value.code
                });
                if (yards && yards.length > 0) {
                    var yaradId = yards[0].YardId;
                    var yardObj = {};
                    yardObj.Code = value.code;
                    yardObj.Name = value.name;
                    yardObj.YardId = yaradId;
                    yardLst.push(yardObj);
                }
            });
            vm.yardsList = yardLst;
            vm.varyard = data.Yards[0].YardId;
        }

        function clickStatus(item) {
            var el = angular.element(document.querySelector('.active.status'));
            el.removeClass('active status');
            vm.varstatus = item.currentTarget.attributes['statusid'].value;
            this.getAppointments();
        }

        function clickActionType(item) {
            var el = angular.element(document.querySelector('.active.action'));
            el.removeClass('active action');
            if (item.currentTarget.attributes['actiontypeid'].value == "ALL") {
                item.currentTarget.attributes['actiontypeid'].value = "";
            }
            vm.varactiontype = item.currentTarget.attributes['actiontypeid'].value;
            this.getAppointments();
        }

        function startDate() {
            $('#txtStartDate').focus();
        }

        function endDate() {
            $('#txtEndDate').focus();
        }

        // function showModalApptView(appointmentId) {
        //     vm1.showModalApptView(appointmentId);
        // }
        function showModalApptView(appointmentId) {
            $scope.appointmentIdSelected = appointmentId;
            $scope.listActionType = listActionType;
            $scope.listOperationType = listOperationType;
            ngDialog.open({
              template: 'app/components/appointment/appointmentDetail.html',
              closeByDocument: false,
              closeByEscape: false,
              scope: $scope,
              preCloseCallback: function (value) {
              }
            });
          }

        function setEmpty(val) {
            if (val == 0 || val == "0" || val == "T")
                val = "";
            return val;
        }

        function getAppointmentPromiseConfig() {
            setDefaultYardIfNotSet();

            var model = {
                AppointmentDateFrom: formatCalendarDate(vm.datevalstart),
                AppointmentDateTo: formatCalendarDate(vm.datevalend),
                AppointmentStatusId: setEmpty(vm.varstatus),
                YardId: setEmpty(vm.varyard),
                ActionType: setEmpty(vm.varactiontype),
                OperationType: setEmpty(vm.varoperationtype),
                ApplicationCode: common.config.applicationCode,
                DefaultLanguageId: 1,
                CurrentRoleCode: vm.roleSelected,
                IsOnlyPortalUser: vm.isOnlyPortalUser,
                CurrentPage: vm.CurrentPage,
                ItemsPerPage: vm.ItemsPerPage
            };

            model = JSON.stringify(model);
            return datacontext.appointment.getAppointments(model);
        }

        function getAppointments() {
            vm.display = true;
            vsblockui.disable({ message: '' });
            return getAppointmentPromiseConfig().then(function (data) {
                LoadAppointmentData(data);
                vm.display = false;
                vsblockui.enable();
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function setDefaultYardIfNotSet() {
            if (Object.keys(vm.varyard).length === 0 && vm.varyard.constructor === Object) {
                var authData = common.localStorageService.get('authorizationData');
                vm.varyard = authData ? (authData.ModelRequester ? authData.ModelRequester.CurrentYardId : {}) : {};
            }
        }
        function downloadExcel() {
            let criteria = {
                AppointmentDateFrom: formatCalendarDate(vm.datevalstart),
                AppointmentDateTo: formatCalendarDate(vm.datevalend),
                AppointmentStatusId: setEmpty(vm.varstatus),
                YardId: setEmpty(vm.varyard),
                ActionType: setEmpty(vm.varactiontype),
                OperationType: setEmpty(vm.varoperationtype),
                ApplicationCode: common.config.applicationCode,
                DefaultLanguageId: 1,
                CurrentRoleCode: vm.roleSelected,
                IsOnlyPortalUser: vm.isOnlyPortalUser,
                CurrentPage: vm.CurrentPage,
                ItemsPerPage: vm.ItemsPerPage
            };
            let nameFile = $translate.instant('views.appointmentSearch.inAndOut');
            datacontext.appointment.getPrintAppointmentsConsolidationExcel(criteria, nameFile);
        }

        function LoadAppointmentData(data) {
            vm.appointments = data.Appointments;
            if (vm.appointments) {
                vm.TotalItems = data.TotalItems;
                SetCorrectAppointmentHours();
                for (var i = 0; i < vm.appointments.length; i++) {
                    vm.appointments[i].OperationTypeCode = vm.appointments[i].OperationType;
                    vm.appointments[i].ActionTypeCode = vm.appointments[i].ActionType;
                    vm.appointments[i].OperationType = vm.nombreTipoOperacion(vm.appointments[i].OperationType);
                    vm.appointments[i].AppointmentDate = vm.formatDisplayDate(vm.appointments[i].AppointmentDate);
                    vm.appointments[i].ActionType = vm.nombreTipoAccion(vm.appointments[i].ActionType);
                }
                vm.nro_registros = vm.appointments.length;
            }

            if (!vm.nro_registros > 0)
                vm.nro_registros = 0;
        }

        function nombreTipoOperacion(val) {
            if (val == "M") {
                return "EMPTY";
            }
            if (val == "I") {
                return "IMPORT";
            }
            if (val == "E") {
                return "EXPORT";
            }
        }

        function nombreTipoAccion(val) {
            if (val == "D") {
                return "DROPOFF";
            } else {
                return "PICKUP";
            }

        }

        function formatCalendarDate(val) {
            if (val && val.length == 8)
                val = val.split("/")[1] + "/" + val.split("/")[0] + "/" + val.split("/")[2];
            else
                val = "";
            return val;
        }

        function formatDisplayDate(val) {
            var d = new Date(val);
            return moment(d).format("DD/MM/YYYY HH:mm:ss");
        }

        function formatDatePortion(val) {

            var n_val = ("0" + val);

            if (n_val.length <= 2)
                return n_val
            else
                return n_val.substr(1, 2);
        }

        function crearBtnTipoOperacion(text) {
            var btnToRender = "<button type='button' class='btn btn-default btn-xs' style='background-color:orange; color: white'><b>" + text + "</b></button>";
            return $sce.trustAsHtml(btnToRender);
        }

        function crearBtnTipoAccion(text) {
            var btnToRender = "<img src='assets/img/icons/drop_off.png' />";

            if (text.indexOf("PICK") >= 0) {
                btnToRender = "<img src='assets/img/icons/pick_up.png' />";
            }

            return $sce.trustAsHtml(btnToRender);
        }

        function crearBtnTipoAccionSmall(text) {

            var btnToRender = "<img id='imgAct' src='assets/img/icons/drop_off.png' style='width:60px'/>";

            if (text.indexOf("PICK") >= 0) {
                btnToRender = "<img id='imgAct' src='assets/img/icons/pick_up.png' style='width:60px'/>";
            }

            return $sce.trustAsHtml(btnToRender);

        }

        function muestraEquipos(idAppointment, mostrar) {
            //si no hubo alguno desplegado el primero en hacerlo sera el ultimo
            if (typeof lastIdAppointment == "undefined") {
                lastIdAppointment = idAppointment;
            }

            $('.row.appt-equ').css('display', 'none');

            if (typeof lastIdAppointment != "undefined") {
                if (typeof document.getElementsByName('p' + lastIdAppointment)[0] != 'undefined') {
                    document.getElementsByName('p' + lastIdAppointment)[0].style.display = "inline-block";
                    document.getElementsByName('m' + lastIdAppointment)[0].style.display = "none";
                }
            }

            //una vez que se haya restaurado el ultimo el actual sera el siguiente en restaurarse despues de que se haya gestionado 
            lastIdAppointment = idAppointment;

            if (mostrar) {

                if (typeof document.getElementsByName('p' + idAppointment)[0] != 'undefined') {
                    document.getElementsByName('p' + idAppointment)[0].style.display = "none";
                    document.getElementsByName('m' + idAppointment)[0].style.display = "inline-block";
                }
                $('[eid=' + idAppointment + ']').show();
                scrollToTarget(idAppointment);

            } else {

                if (typeof document.getElementsByName('p' + idAppointment)[0] != 'undefined') {
                    document.getElementsByName('p' + idAppointment)[0].style.display = "inline-block";
                    document.getElementsByName('m' + idAppointment)[0].style.display = "none";
                }
                $('[eid=' + idAppointment + ']').hide();
            }
        }

        function muestraAcordeon(idAppointment) {
            $('.row.appt-equ').css('display', 'none');
            $('.left-arrow').css('display', 'none');
            $('.right-arrow').css('display', 'inline-block');

            if ($('[eid=' + idAppointment + ']').is(":visible")) {
                if (typeof document.getElementsByName('p' + idAppointment)[0] != 'undefined') {
                    document.getElementsByName('p' + idAppointment)[0].style.display = "inline-block";
                    document.getElementsByName('m' + idAppointment)[0].style.display = "none";
                }
                $('[eid=' + idAppointment + ']').hide();
            } else {
                if (typeof document.getElementsByName('p' + idAppointment)[0] != 'undefined') {
                    document.getElementsByName('p' + idAppointment)[0].style.display = "none";
                    document.getElementsByName('m' + idAppointment)[0].style.display = "inline-block";
                }
                $('[eid=' + idAppointment + ']').show();
                scrollToTarget(idAppointment);
            }
        }

        function scrollToTarget(idAppointment) {
            var selector = '[aid=' + idAppointment + ']';
            var fromContainerPos = $(selector).position().top;
            var fromTopPagePos = $(selector).offset().top;

            $('#resultsContainer').animate({
                scrollTop: $('#resultsContainer').scrollTop() + fromContainerPos
            }, 500);

            $(".appt-equ-popup").hide();
            $(".appt-equ-popup").fadeIn(1400);
        }


        function redirectAction(Type) {

            switch (Type) {
                case 'D':
                    $window.sessionStorage.type = Type;
                    $state.go("root.appointmentMainApptSchedule", $stateParams, { reload: false, inherit: false, notify: true });
                    break;
                case 'P':
                    $window.sessionStorage.type = Type;
                    $state.go("root.appointmentMainApptSchedule", $stateParams, { reload: false, inherit: false, notify: true });
                    break;
            }
        }

        function SetCorrectAppointmentHours() {
            $(vm.appointments).each(function (e, v) {
                var apptDate = new Date(v.AppointmentDateString);
                v.AppointmentDate = moment(apptDate).format();
            });
        }
    }

})();